// Punto central de los servicios, accesos y escenarios, ubicado sobre un camino del parque.
export const simulatedPosition = [25.680043, -100.281525]
